import * as React from 'react';
import { Modal, Button, Icon } from 'antd';

import { $data } from '../services/data/JayDataContext';
import { MapView, SearchBox, MapMarker } from './map.view';
import { TextView } from './text.view';

interface MapDialogViewProps {
	mode: ControlMode;
	location: Geography;
	onChangeLocation: (e: Geography) => void;
	zoom: number;
	withoutText?: boolean;
}

interface MapDialogViewState {
	showModal: boolean;
	location?: Partial<Geography>;
}

export class MapDialogView extends React.Component<MapDialogViewProps, MapDialogViewState> {
	constructor(props: Readonly<MapDialogViewProps>) {
		super(props);

		this.state = {
			showModal: false,
			location: props.location
		};
	}

	private setLatLon = (e: { lat: number; lng: number; }) => {
		if (this.props.mode == 'edit') {
			const location = new $data.Geography() as any;
			location.latitude = e.lat;
			location.longitude = e.lng;
			this.setState({ location: location });
		}
	}

	private acceptDialog = (ev?: React.MouseEvent<HTMLButtonElement>): void => {
		this.props.onChangeLocation(this.state.location as any);
		this.closeDialog(ev);
	}

	private closeDialog = (ev?: React.MouseEvent<HTMLButtonElement>): void => {
		if (ev != null) {
			ev.preventDefault();
		}
		this.setState({ showModal: false });
	}

	render(): React.ReactNode {
		const lat = this.state.location != null ? this.state.location.coordinates[1] : null;
		const lng = this.state.location != null ? this.state.location.coordinates[0] : null;

		const button = (
			<Button
				className={this.props.withoutText ? undefined : "square-button"}
				type="primary"
				icon="environment"
				onClick={() => this.setState({ showModal: true })}>
			</Button>
		);
		const body = this.props.withoutText
			? button
			: (
				<TextView
					mode={this.props.mode}
					value={this.state.location != null ? `${lat}, ${lng}` : ''}
					label="Location"
					onChanged={(e: string) => {
						const lastSpacePos = e.lastIndexOf(',');
						if (lastSpacePos > 0) {
							const lat = parseFloat(e.substring(0, lastSpacePos).trim());
							const lon = parseFloat(e.substring(lastSpacePos + 1).trim());
							if (isNaN(lat) || isNaN(lon)) {
								return;
							}
							const location = new $data.Geography() as any;
							location.latitude = lat;
							location.longitude = lon;
							location.type = "Point";
							this.setState({
								location
							});
						} else if (e == null || e == '') {
							this.setState({
								location: null
							});
						}
					}}
					addonClass="addon-button"
					addonAfter={button}
				/>
			);
		return (
			<div>
				<Modal
					visible={this.state.showModal}
					style={{ top: 20 }}
					width="65%"
					onCancel={this.closeDialog}
					title="Click on a point for set Location"
					maskClosable={false}
					footer={[
						<Button
							key="cancel"
							type="primary"
							onClick={this.acceptDialog}>
							Close
						</Button>
					]}>
					<SearchBox
						placeholder="Places"
						onPlacesChanged={this.setLatLon}
						mode={this.props.mode}
					/>
					<div style={{ width: '100%', height: '70vh' }}>
						<MapView
							center={{ lat: lat, lng: lng }}
							zoom={this.props.zoom}
							onClick={this.setLatLon}>
							<MapMarker lat={lat} lng={lng} />
						</MapView>
					</div>
					<br />
					{this.state.location ? `${lat}, ${lng}` : null}
				</Modal>
				{body}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/map-dialog.view.tsx